var map = {
	"./about-us-banner-cn.webp": 1962,
	"./about-us-banner.webp": 380,
	"./banner-01.jpg": 1963,
	"./banner-slot.jpg": 1964,
	"./bet-and-earn-banner-cn.webp": 1965,
	"./bet-and-earn-banner-indon.webp": 1966,
	"./bet-and-earn-banner-ms.webp": 1967,
	"./bet-and-earn-banner.webp": 1968,
	"./check-in-banner-cn.webp": 1969,
	"./check-in-banner-id.webp": 1970,
	"./check-in-banner-ms.webp": 1971,
	"./check-in-banner.webp": 1972,
	"./cny_2024-bm.webp": 1973,
	"./cny_2024-cn.webp": 1974,
	"./cny_2024.webp": 1975,
	"./epl-banner-cn.webp": 1976,
	"./epl-banner-indo.webp": 1977,
	"./epl-banner-ms.webp": 1978,
	"./epl-banner.webp": 1979,
	"./lb-m-banner-cn.webp": 1980,
	"./lb-m-banner.webp": 1981,
	"./leaderboard-banner-cn.webp": 1982,
	"./leaderboard-banner.webp": 1983,
	"./lottery-banner.webp": 1984,
	"./lucky-spin-banner-cn.webp": 1985,
	"./lucky-spin-banner-ms.webp": 1986,
	"./lucky-spin-banner.webp": 1987,
	"./p2p-banner.webp": 1988,
	"./premier-league-banner-cn.webp": 1989,
	"./premier-league-banner.webp": 1990,
	"./promo-vip-banner-cn.webp": 1991,
	"./promo-vip-banner.webp": 1992,
	"./promos-banner-cn.webp": 1993,
	"./promos-banner-indon.webp": 1994,
	"./promos-banner-ms.webp": 1995,
	"./promos-banner.webp": 1996,
	"./promos-detail-banner.jpg": 1997,
	"./side-bar-banner.jpg": 1998,
	"./vip-banner-cn.webp": 1999,
	"./vip-banner-id.webp": 2000,
	"./vip-banner-mobile.webp": 2001,
	"./vip-banner-ms.webp": 2002,
	"./vip-banner.webp": 2003,
	"./winner-leaderboard-banner-cn.webp": 2004,
	"./winner-leaderboard-banner.webp": 2005,
	"./world-cup-banner-cn.webp": 2006,
	"./world-cup-banner.webp": 2007,
	"./world-cup-two-banner-cn.webp": 2008,
	"./world-cup-two-banner.webp": 2009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;